// 客服2菜单
const menus = [
  {
    icon: 'el-icon-lx-home',
    index: '/simpleIndex',
    title: '系统首页',
  },
  {
    icon: 'el-icon-goods',
    index: '2',
    title: '商品管理',
    subs: [
      {
        index: '/goodsList',
        title: '商品列表',
      },
      {
        index: '/indexGoodsList',
        title: '首页商品管理',
      },
      {
        index: '/classify',
        title: '分类列表',
      },
      {
        index: '/goodsAuditList',
        title: '商品审核',
      },
    ],
  },

]

export default menus
